import React, { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

const easeOut = (t) => 1 - Math.pow(1 - t, 3);

export const CountUp = ({ value, duration = 1800, className }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-30px" });
  const m = String(value).match(/^(\d+(?:[.,]\d+)?)([\s\S]*)$/);
  const numStr = m ? m[1].replace(",", ".") : null;
  const suffix = m ? m[2] : "";
  const target = numStr ? parseFloat(numStr) : 0;
  const decimals = numStr && numStr.includes(".") ? numStr.split(".")[1].length : 0;
  const pad = numStr && numStr.startsWith("0") ? numStr.length : 0;
  const [display, setDisplay] = useState(m ? `${(0).toFixed(decimals).padStart(pad, "0")}${suffix}` : String(value));

  useEffect(() => {
    if (!inView || !m) return;
    let raf;
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      const v = (target * easeOut(p)).toFixed(decimals);
      setDisplay(`${String(v).padStart(pad + (decimals ? decimals + 1 : 0), "0")}${suffix}`);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  return (
    <span ref={ref} className={className} style={{ fontVariantNumeric: "tabular-nums" }}>
      {display}
    </span>
  );
};
